function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cn from "classnames";
import DayPicker, { LocaleUtils } from "react-day-picker";
import { getYear, format } from "date-fns";
import { noop } from "../../lib/utils";
import ChevronIcon from "../../images/Chevron";
import "react-day-picker/lib/style.css";
import "../../styles/date/date-picker.scss";
const TITLE_FORMAT = "MMMM yyyy";
const WEEKDAYS_SHORT = ["S", "M", "T", "W", "T", "F", "S"];

const Navbar = ({
  onPreviousClick,
  onNextClick
}) => {
  const handleKeyDown = e => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      // Preventing from moving years using up and down arrows
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "otrl-ui__date-picker__month-selector"
  }, /*#__PURE__*/React.createElement("button", {
    className: "otrl-ui__date-picker__month-selector__button otrl-ui__date-picker__month-selector__button--prev",
    onClick: () => onPreviousClick(),
    onKeyDown: handleKeyDown,
    tabIndex: "-1",
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    className: "otrl-ui__date-picker__month-selector__button__arrow-left"
  })), /*#__PURE__*/React.createElement("button", {
    className: "otrl-ui__date-picker__month-selector__button otrl-ui__date-picker__month-selector__button--next",
    onClick: () => onNextClick(),
    onKeyDown: handleKeyDown,
    tabIndex: "-1",
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    className: "otrl-ui__date-picker__month-selector__button__arrow-left"
  })));
};

const DatePicker = ({
  formatTitle = TITLE_FORMAT,
  onChange = noop,
  selected,
  maxDate,
  minDate,
  initialMonthDate,
  className,
  ...props
}) => {
  const formatMonthTitle = date => {
    let yearText = !formatTitle.includes("yyy") && getYear(new Date()) !== getYear(date) ? ` ${format(date, "yyyy")}` : "";
    return /*#__PURE__*/React.createElement("span", null, format(date, formatTitle), yearText);
  };

  const handleDayClick = (date, {
    disabled
  }) => {
    if (!disabled) {
      onChange(date);
    }
  };

  return /*#__PURE__*/React.createElement(DayPicker, _extends({
    className: cn("otrl-ui__date-picker", className),
    disabledDays: [{ ...(minDate ? {
        before: minDate
      } : {
        before: new Date()
      }),
      ...(maxDate && {
        after: maxDate
      })
    }],
    initialMonth: initialMonthDate || selected,
    fromMonth: new Date(),
    weekdaysShort: WEEKDAYS_SHORT,
    localeUtils: { ...LocaleUtils,
      formatMonthTitle
    },
    modifiers: {
      disabled: { ...(minDate ? {
          before: minDate
        } : {
          before: new Date()
        }),
        ...(maxDate && {
          after: maxDate
        })
      }
    },
    navbarElement: /*#__PURE__*/React.createElement(Navbar, null),
    onDayClick: handleDayClick,
    selectedDays: selected
  }, props));
};

export default DatePicker;